import FormattedMessage from 'I18n/components/FormattedMessage';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import UIButton from 'UIComponents/button/UIButton';
import styled, { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import usageTracker from '../../utils/usageTracker';
import { getSignupCtaHref } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSection = styled.section.withConfig({
  displayName: "SignupSectionMinimalDark__StyledSection",
  componentId: "th67o9-0"
})(["background-color:", ";"], theme.colors.HEFFALUMP);
const SignupSectionMinimalDark = ({
  hubsSignupCta
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const handleSignupClick = () => {
    usageTracker.track('interaction', {
      action: 'signup-button-click',
      value: hubsSignupCta
    });
  };
  return /*#__PURE__*/_jsx(StyledSection, {
    className: "p-all-5",
    children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex-wrap align-center justify-center",
        style: {
          rowGap: '15px',
          columnGap: '40px'
        },
        children: [/*#__PURE__*/_jsx("p", {
          className: "m-bottom-0 text-center",
          style: {
            color: 'white'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.signupSectionMinimal.description"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          href: getSignupCtaHref(hubsSignupCta),
          onClick: () => handleSignupClick(),
          size: isMobile ? 'small' : 'medium',
          use: "primary-white",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.signupSectionMinimal.ctaText"
          })
        })]
      })
    })
  });
};
export default SignupSectionMinimalDark;